import React, { useState, useEffect } from "react";
import "./InfoArea.scss";
import { BsSearch } from "react-icons/bs";
import Breadcrumb from "../../../common/Breadcrumb/Breadcrumb";
import { ImgPDF, ImgDownload, ImgAlert } from "../../../../components/dashboard/pages/glovesSelector/glovesSelection";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetInfoAreaResultsQuery } from "../../../../services/getInfoArea";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { kclRootState } from "../../../../store/gloveSelectorStore";
import { ErrorBoundary } from "react-error-boundary";
import Loader from "../../../common/Loader/Loader";
import { addAnalytics } from "../../../common/functions/utils";
import { utilAnalytics } from "../../../common/analytics/analyticsUtil";
const DownloadPDF = React.lazy(
  () => import("WacReusableComponentGroup/DownloadPDF")
);
let infoareaflag = false;
const InfoArea = () => {
  const [displayItems, setDisplayItems] = useState<number>(15);
  const [searchTermText, setSearchTermText] = useState<string>("");
  const [sucessMsg, setSucessMsg] = useState<boolean>(true);
  const [flag, setFlag] = useState<boolean>(false);
  const { t } = useTranslation();
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const closeWarning = () => setShowAlert(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [totalResults, setTotalResults] = useState<number>(0);


  const navigate = useNavigate();
  const { PAGE_NAVIGATION } = useSelector(
    (state: kclRootState) => state?.glovesSelector?.config || {}
  );
  const language = useSelector(
    (state: kclRootState) => state?.glovesSelector?.language || "en-US"
  );
  // api integration

  //const facetPayloadReq = INFO_AREA_BASE_QUERY (searchTermText,"");
  const { data: newDataInfoResults, isLoading: isLoadingInfo } =
    useGetInfoAreaResultsQuery({
      jwtToken: "",
      calculatorId: "gloveSelector",
      searchType: "searchGlove",
      appId: "",
      language: "",
      HON_ORG_ID: "SPS",
      payload: {
        query: searchTermText,
        filters: {
          all: [
            {
              document_type: "Info Area Documents",
            },
            {
              language: language == "de" ? "de-DE" : "en-US",
            },
          ],
        },
        search_fields: {
          title: {
            weight: 5,
          },
        },
        sort: [
          {
            title: "asc",
          },
        ],
        precision: 8,
        page: {
          current: 1,
          size: 1000,
        },
      },
    });
  const [infoResults, setInfoResults] = useState<[]>([]);
  const loadMore = () => {
    setDisplayItems(displayItems + 10);
  };

  useEffect(() => {

    const results = newDataInfoResults?.result?.results;
    const totalResults = newDataInfoResults?.result?.meta?.page?.total_results;
    setInfoResults(results);
    setSucessMsg(newDataInfoResults?.isSuccess);
    setTotalRecords(results?.length);
    setTotalResults(totalResults);
    if (newDataInfoResults?.isSuccess == false) {
      setShowAlert(true);
    }


  }, [newDataInfoResults, searchTermText]);

  useEffect(() => {
    const totalResults = newDataInfoResults?.result?.meta?.page?.total_results;
    if (flag == true) {
      sendAdobeAnalytics(totalResults);
      setFlag(false);
    }


  }, [flag]);


  const handleSearch = (e) => {
    setSearchTermText(e.target.value);
  };

  const handlerEnter = (e) => {
    if (e.keyCode === 13) {
      setFlag(true)
      const customData = {
        "event": "searchClick",
        searchKeyword: searchTermText,
        searchResultNumber: totalResults
      };
      addAnalytics(customData);
    }

  };
  const sendAdobeAnalytics = (len: number) => {
    utilAnalytics(
      true,
      {
        event: "searchClick",
        _honeywellinternationalinc:
        {
          search:
          {
            searchTerm: searchTermText,
            searchResults: len,
            secondarySearchTerm: "",
            searchCategory: "GS-Info Area",
            allSearches: { "value": 1 },
            unsuccessfulSearches:
            {
              value: len == 0 ? 1 : 0
            }
          }

        }

      },
      "/info-area"
    );
  }

  const errorBack = () => {
    navigate(PAGE_NAVIGATION.HOME);
  };
  const errorRefresh = () => {
    navigate(PAGE_NAVIGATION.HOME);
  };

  function downloadEvent(file, url) {
    const customData = {
      "event": "downloadInfofile",
      fileName: file
    };
    addAnalytics(customData);
    utilAnalytics(
      true,
      {
        event: "documentClick",
        _honeywellinternationalinc:
        {
          document:
          {
            title: file,
            type: "PDF",
            gatedStatus: true,
            URL: url,
            download:
            {
              value: 1
            }

          }

        }

      },
      "/chemical-search"
    );
  }
  return (
    <>
      <Breadcrumb />
      <div className="info-area">
        <div className="main-title">
          <div className="textstart">
            <div className="heading"> {t("kclGloves.Info_Area")}</div>
          </div>
          <div className="text-end search-bar">
            <span className="search-icon">
              <BsSearch />
            </span>
            <input
              type="text"
              placeholder={t("kclGloves.Search_File_Name")}
              onChange={handleSearch}
              onKeyDown={handlerEnter}
            />
          </div>
        </div>
        {isLoadingInfo && (
          <>
            <Loader />
          </>
        )}
        {!isLoadingInfo && (
          <div className="row">
            <div className="area-table">
              <div className="panel-body">
                <div className="table-head">
                  <div className="table-items">{t("kclGloves.Type")} </div>
                  <div className="table-items">{t("kclGloves.File_Name")}</div>
                  <div className="table-items"></div>
                </div>
                {totalRecords == 0 || sucessMsg == false ? (
                  <>
                    {totalRecords == 0 ? (
                      <>
                        <div className="col-md-8 col-12 no-results-found">
                          <div className="title">
                            {t("kclGloves.No_Results_Found")}
                          </div>
                          {searchTermText && (
                            <div className="subTitle">
                              '{searchTermText}'
                              <span>{t("kclGloves.Please_Try_Later")}</span>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <Modal
                          show={showAlert}
                          onHide={closeWarning}
                          animation={false}
                          aria-labelledby="MaxFilterWarning"
                          centered
                          className="facet-maxfilter-modal"
                        >
                          <Modal.Body className="mx-2">
                            <div className="row mx-0">
                              <div className="col-sm-2">
                                <img
                                  src={ImgAlert}
                                  alt="Warning"
                                  className="warning-icon"
                                />
                              </div>
                              <div className="col-sm-10">
                                <div className="heading">
                                  {t("kclGloves.Error")}
                                </div>
                                {t("kclGloves.Unable_connect_server")}
                              </div>
                            </div>
                            <div className="cta-btns mt-3 text-end">
                              <div
                                className="button button-outline"
                                onClick={errorRefresh}
                              >
                                {t("kclGloves.Restart")}
                              </div>
                              <div
                                className="button button-primary"
                                onClick={errorBack}
                              >
                                {t("kclGloves.Go_Back")}
                              </div>
                            </div>
                          </Modal.Body>
                        </Modal>
                      </>
                    )}
                  </>
                ) : (
                  infoResults
                    ?.slice(0, displayItems)
                    .map((item: any, index) => (
                      <>
                        <div className="row-entries" key={index}>
                          <div className="table-data">
                            <img
                              src={ImgPDF}
                              alt="PDF Download"
                              className="pdf-icon"
                            />
                          </div>
                          <div className="table-data">{item?.title?.raw}</div>
                          <div className="table-data" file-url={item?.url?.raw} onClick={() => downloadEvent(item?.title?.raw, item?.url?.raw)}>
                            <ErrorBoundary
                              FallbackComponent={() => <Loader />}
                            >
                              <div className="download-pdf" file-name={item?.title?.raw}>
                                <React.Suspense fallback={"..."}>
                                  <DownloadPDF
                                    label={t("kclGloves.DOWNLOAD")}
                                    type={"link"}
                                    pdfUrl={item?.url?.raw}
                                    file-name={item?.title?.raw}
                                  />
                                </React.Suspense>
                              </div>
                            </ErrorBoundary>

                            <ErrorBoundary
                              FallbackComponent={() => <Loader />}
                            >
                              <React.Suspense fallback={"..."}>
                                <div className="doc-icon" file-name={item?.title?.raw}>
                                  <DownloadPDF
                                    type={"custom"}
                                    pdfUrl={item?.url?.raw}
                                  >
                                    <img
                                      src={ImgDownload}
                                      alt={t("kclGloves.DOWNLOAD")}
                                    />
                                  </DownloadPDF>
                                </div>
                              </React.Suspense>
                            </ErrorBoundary>
                          </div>
                        </div>
                      </>
                    ))
                )}
              </div>
            </div>
          </div>
        )}
        {displayItems < infoResults?.length && (
          <div className="button button-outline" onClick={() => loadMore()}>
            LOAD MORE
          </div>
        )}
      </div>
    </>
  );
};

export default InfoArea;
